import React from 'react'

interface MoqIconProps {
  color?: string
  size?: number | string
  className?: string
}

export const MoqIcon: React.FC<MoqIconProps> = ({
  color = 'currentColor',
  size = 20,
  className,
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    {/* Stacked boxes representing minimum order quantity */}
    <rect
      x="4"
      y="12"
      width="6"
      height="6"
      rx="1"
      stroke={color}
      strokeWidth="2"
      fill="none"
    />
    <rect
      x="6"
      y="8"
      width="6"
      height="6"
      rx="1"
      stroke={color}
      strokeWidth="2"
      fill="none"
    />
    <rect
      x="8"
      y="4"
      width="6"
      height="6"
      rx="1"
      stroke={color}
      strokeWidth="2"
      fill="none"
    />
    {/* Quantity indicator */}
    <path
      d="M16 8H20M16 12H20M16 16H20"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
)

export default MoqIcon
